import Rule from "./rule";

class CartTotalRule extends Rule {
  type = "cart.total";

  constructor(config = {}) {
    super(config);

    this.config.conditions = this.config.conditions || [];
  }

  evaluate(data) {
    super.evaluate(data);
    
    this.log = [];
    console.groupCollapsed(this.logPrefix);
    console.log('Config', this.config);
    
    let pass = true;
    // Filter cart items to only those that pass any conditions specified
    let applicableItems = data.response.items.filter(item => {
      return this.config.conditions.every(condition => {
        return this.comparatorFunctions[condition.comparator || "eq"](item[condition.key], condition.value)
      });
    });

    // Calculate total of applicable items
    let applicableTotal = applicableItems.reduce((previousValue, item) => {
      return previousValue + item.final_line_price
    }, 0);

    pass = this.comparatorFunctions[this.config.comparator](applicableTotal, this.config.value)

    this.addLog(pass, this.config.value, applicableTotal, this.config.comparator);

    console.log('Pass?', pass);
    console.groupEnd();
    return pass;
  }

  explain() {
    let message = `cart applicable items' total price is ${this.config.comparator} ${this.config.value}`;
    let submessages = [];
    if(this.config.conditions.length > 0){
      submessages = ["and items match "+this.config.conditions.map(({ key, comparator, value }) => `property '${key}' ${comparator} '${value}'`).join(' and ')];
    }

    return `${message} ${submessages.join(" and ")}`;
  }
}

export default CartTotalRule;